import { render, staticRenderFns } from "./sliderPhone.vue?vue&type=template&id=1eb787d8&scoped=true&"
import script from "./sliderPhone.vue?vue&type=script&lang=js&"
export * from "./sliderPhone.vue?vue&type=script&lang=js&"
import style0 from "./sliderPhone.vue?vue&type=style&index=0&id=1eb787d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb787d8",
  null
  
)

export default component.exports